// src/landings/components/resources/ArticleTableOfContents.tsx
interface ArticleTableOfContentsProps {
    articles: Array<{
      id: string;
      title: string;
    }>;
    activeArticle: string | null;
  }
  
  function ArticleTableOfContents({ articles, activeArticle }: ArticleTableOfContentsProps) {
    if (articles.length === 0) return null;
    
    return (
      <div className="lg:w-1/5">
        <div className="sticky top-28 bg-white rounded-xl p-5 border border-[#e2dad3] shadow-sm">
          <h3 className="font-bold text-base text-[#694e42] mb-3 pb-2 border-b border-[#e2dad3]">
            On This Page
          </h3>
          <ul className="space-y-1">
            {articles.map((article) => (
              <li key={article.id}>
                <a
                  href={`#${article.id}`}
                  className={`block py-1.5 px-2 rounded-md text-sm transition-colors ${
                    activeArticle === article.id
                      ? "bg-[#fff5eb] font-medium text-[#ff8c42]"
                      : "text-[#8a7266] hover:bg-[#f9f6f4] hover:text-[#694e42]"
                  }`}
                >
                  {article.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
  
  export default ArticleTableOfContents;